import { TBuilderPromoBanner } from '../types';

export type TUTMCampaign = TBuilderPromoBanner;

export function getUTMDataForLink(campaign: TUTMCampaign, offerId: number, term?: string | number) {
  const params = [
    'utm_source=cian',
    'utm_medium=card',
    `utm_campaign=${campaign}`,
    `utm_content=${offerId}`,
    !!term && `utm_term=${term}`,
  ].filter(Boolean);

  return params.join('&');
}
